import { render } from "./LoginSetting.vue?vue&type=template&id=2d69fac3"
import script from "./LoginSetting.vue?vue&type=script&lang=js"
export * from "./LoginSetting.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__